// extracted by mini-css-extract-plugin
export default {"pageContent":"DocumentsPage_pageContent__dlelP"};